import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import { Autocomplete, TextField, InputAdornment } from "@mui/material";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import AccountCircle from "@mui/icons-material/AccountCircle";
import { useGetUsersQuery } from "../../../features/users/usersApiSlice";
import { useGetdesignationsQuery } from "../../../features/designations/designationApiSlice";
import { useGetofficetypeQuery } from "../../../features/officetype/officetypeApiSlice";
import { useGetStoreOfficesQuery } from "../../../features/storeoffices/storeofficesApiSlice";
import { useGetdesignationsuffixQuery } from "../../../features/designationsuffix/designationSuffixApiSlice";
import { useGetofficesQuery } from "../../../features/offices/officesApiSlice";
import { useAddNewjoinoffreqMutation, useGetjoinoffreqQuery } from "../../../features/joinoffreq/joinOffReqApiSlice";
import useAuth from "../../../features/hooks/useAuth";
import { CommonButton } from "../../../Styles/CommonStyles";

/* Styled Components */
const MainHeading = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 10px 0 5px 20px;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: #5c5891;
`;

const HeadingField = styled.div`
  font-weight: bold;
  margin-bottom: 20px;
`;

const SubHeadingField = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 10px 0 5px 5px;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: #5c5891;
`;

const BackArrowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 20px;
  cursor: pointer;
`;

const AddUser = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 20px;
`;

const AddUserFormContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 20px;
`;

const LabelInputWrapper = styled.div`
  display: ${(props) => props.disp};
  min-height: 80px;
  margin-right: 40px;
`;

const LabelInputWrapper1 = styled.div`
  flex: 1 0 30%;
  display: ${(props) => props.disp};
  min-height: 80px;
  margin-right: 40px;
`;

const SubmitButton = styled(CommonButton)`
  height: 40px;
  margin: 0;
  background-color: #5c5891;
`;

const JoinOfficeReq = ({userData, compToggle, setCompToggle}) =>{

    const Auth = useAuth();
    const [addJoinOffReq] = useAddNewjoinoffreqMutation();


    const userRef = useRef();
    const count = useRef(0);


    const initialUserState = {
      name:{firstName:"", middleName:"", lastName:""},
      email:"",
      currentOffice:"",
      office:{mainCharge:"", additionalCharge:[]},
      designation:{},
      designationSuffix:{},
      numSuffix:{},
      roles:{},
      reqType:"joinoffreq",
      chargeType:"",
      submissionDate: new Date(Date.now()).toISOString(),
      active:true
    }

  
  const initialValueState = {
    email:"",
    currentOffice:"",
    designation:"",
    designationsuffix:"",
    level0:"",
    level1:"",
    level2:"",
    level3:"",
    level4:"",
    level5:"",
    store:"",
    charge:""
}
    const [subdispl, setSubdispl] = useState("none");
    const [presentOffType, setPresentOffType] = useState();
    const [officeType, setOfficeType] = useState([]);
    const [reportingOfficer, setReportingOfficer] = useState();
    const [desigSuffix, setDesigSuffix] = useState([]);
    const [offices, setOffices] = useState([]);
    const [renderFields, setRenderFields] = useState([]);
    const [users, setUsers] = useState(initialUserState);
    const [currentUser, setCurrentUser] = useState({});
    const [value, setValue] = useState(initialValueState)
    const [desig, setDesig] = useState([])
    const [displ, setDispl] = useState({
        level1:"block",
        level2:"none",
        level3:"none",
        level4:"none",
        level5:"none",
    })

    const [errMsg, setErrMsg] = useState('');
    const [success, setSuccess] = useState(false);


    useEffect(() => {
      count.current = count.current + 1;
    });

    useEffect(() => {
        userRef?.current?.focus();
    }, [])

    const {officedata} = useGetofficesQuery("officeList", {
      selectFromResult: ({ data }) => ({
        officedata: data?.entities
      }),
    })
  
    const {officetype} = useGetofficetypeQuery("officeTypeList", {
      selectFromResult: ({ data }) => ({
        officetype: data?.entities
      }),
    })
  
    const {designationsuffix}= useGetdesignationsuffixQuery("desigsuffix", {
      selectFromResult: ({ data }) => ({
        designationsuffix: data?.entities
      }),
    })
    const {storeoffices}= useGetStoreOfficesQuery("storeoffices", {
      selectFromResult: ({ data }) => ({
        storeoffices: data?.entities
      }),
    })
  
    const {designation} = useGetdesignationsQuery("designations", {
      selectFromResult: ({ data }) => ({
          designation: data?.entities
        }),
    })
  
    const {userdata} = useGetUsersQuery("usersList", {
      selectFromResult: ({ data }) => ({
        userdata: data?.entities
      }),
    })

    const {joinoffreqdata} = useGetjoinoffreqQuery("joinoffreqList", {
      selectFromResult: ({ data }) => ({
        joinoffreqdata: data?.entities
      }),
    })


    //Create a variable to store all the possible office types against a office level
    let officeTypeLabels = {}
    let i=1
    for(let val of officeType ){
      if(!Object.keys(officeTypeLabels).includes(val.level)){
        officeTypeLabels[val.level] = []
      }
      officeTypeLabels[val.level].push(val.type)
    }

    console.log(officeTypeLabels)
    
    const onChangeuserform = (event, newValue, name) => {
      let tempUser = structuredClone(users);
      let tempValue = { ...value };
      tempUser.name = userData[Auth.id].name;
  
      if (name?.includes("level")) {
          const levelIndex = parseInt(name.replace("level", ""), 10);
  
          if (newValue) {
              // Assigning office based on mainCharge availability
              if (!userData[Auth.id].office.mainCharge.length) {
                  tempUser.office.mainCharge = newValue;
                  tempUser.currentOffice = newValue;
                  tempUser.chargeType = "main";
              } else {
                  tempUser.office.additionalCharge = [...userData[Auth.id].office.additionalCharge, newValue];
                  tempUser.currentOffice = newValue;
                  tempUser.chargeType = "additional";
              }
  
              tempValue = { ...tempValue, [name]: newValue, currentOffice: newValue };
              setPresentOffType(offices.find(x => x.name === newValue)?.type || "");
          } else {
              // Reset lower levels when a selection is cleared
              for (let i = levelIndex; i < 7; i++) {
                  tempValue[`level${i}`] = "";
              }
  
              const previousOffice = value[`level${levelIndex - 1}`];
              tempUser.currentOffice = previousOffice || "";
              tempUser.chargeType = previousOffice ? "main" : "";
  
              tempValue.currentOffice = previousOffice || "";
              setPresentOffType(offices.find(x => x.name === previousOffice)?.type || "");
          }
      }
  
      if (name === "designation") {
          tempUser.designation[value.currentOffice] = newValue;
      }
  
      if (name === "designationSuffix") {
          tempUser.designationSuffix[value.currentOffice] = newValue;
      }
  
      if (name === "charge") {
          tempValue.charge = newValue;
          if (newValue === "Main") {
              if (userData[Auth.id].office.mainCharge.length) {
                  return alert("Main Charge is occupied. Please relieve the previous holder first.");
              }
              tempUser.chargeType = "main";
          } else if (newValue === "Additional") {
              tempUser.chargeType = "additional";
          }
      }
  
      setUsers(tempUser);
      setValue(tempValue);
  };
   

    let id = offices?.find(x => x.name ===  value.currentOffice)?._id
    let officeBody = {"id":id};

    //Check this filter
    const sameOfficeUsers = Object.values(userData)?.filter(x => ((x.office.mainCharge ===  value.currentOffice) || (x.office.additionalCharge.includes( value.currentOffice))) && x.office.mainCharge.length)
    const sameOfficeDesgnUsers = sameOfficeUsers?.filter(x => Object.values(x.designation)?.includes(users.designation[value?.currentOffice]))
    //Sort users having same office and designation in order of numIndex using Quick Sort Algorithm.

    const sortedSameOfficeDesgnUsers = sameOfficeDesgnUsers?.sort((a,b) => (a.numSuffix[presentOffType] > b.numSuffix[presentOffType]) ? 1 : ((b.numSuffix[presentOffType] > a.numSuffix[presentOffType]) ? -1 : 0))

    const onClickConfirm = () => {
        let tempUsers = structuredClone(users);
        if(!currentUser.office?.mainCharge?.length && value.charge === "Additional"){
          return alert("Main Office cannot be vacant if Additional Charge is opted");
        }
        //Check if the selected office and designation combination already exists.
        if(currentUser.office.additionalCharge.concat(currentUser.office.mainCharge).includes(value.currentOffice) && currentUser.designation[users.currentOffice] === users?.designation[users.currentOffice]){
          return alert("The requested Office is already allocated. Choice may be reviewed.")
        }
        if(!users?.designation[value.currentOffice]?.length){
          return alert("Please select designation")
        }
        if(!value?.charge?.length){
          return alert("Please select Charge type")
        }
        setSubdispl("block");   

        if(!sortedSameOfficeDesgnUsers?.length){
          tempUsers.numSuffix[value.currentOffice] = 1;
        }
        for(let i = 1; i < (sortedSameOfficeDesgnUsers?.length + 1); i++){
          if(sortedSameOfficeDesgnUsers[i-1]?.numSuffix !== (sortedSameOfficeDesgnUsers[i]?.numSuffix-1)){
            tempUsers.numSuffix[value.currentOffice] = i+1;
            break;
          }           
        }
        if(( value.currentOffice === offices?.find(x => x.level === "level1").name) && (officeType.find(x=> x.type=== presentOffType)?.UnitHead?.includes(users?.designation[value.currentOffice]))){
          console.log("first")
          if(tempUsers.roles[value.currentOffice]?.length){
            tempUsers.roles[value.currentOffice]?.push("UnitHead");
          }else{
            tempUsers.roles[value.currentOffice] = ["UnitHead"];
          }
          setReportingOfficer("Not Applicable");
        }else{
          if(officeType?.find(x=> x.type=== presentOffType)?.unitHead?.includes(users.designation[value.currentOffice])){
            console.log("second")
            if(tempUsers.roles[value.currentOffice]?.length){
              tempUsers.roles[value.currentOffice]?.push("UnitHead");
            }else{
              tempUsers.roles[value.currentOffice] = ["UnitHead"];
            }
            let supOffice = offices?.find(x => x.name ===  value.currentOffice).superioroffice;
            let repoOfficer = offices?.find(a => a.name === supOffice).unitHead;
            if(repoOfficer?.length) {
                console.log(supOffice)
              console.log("third")
              setReportingOfficer(repoOfficer);
            }else{setSubdispl("none"); alert("Reporting Officer not Registered"); console.log("fourth")}
          } else {
            console.log("fifth")
            if(offices?.find(x => x.name ===  value.currentOffice)?.unitHead?.length){
            console.log("sixth")
            console.log(offices.find(x => x.name ===  value.currentOffice).unitHead)
            setReportingOfficer(offices.find(x => x.name ===  value.currentOffice).unitHead)
            }else{setSubdispl("none"); alert("Reporting Officer not Registered"); console.log("Seventh")}
          }
      }    

      if(( value.currentOffice === offices?.find(x => x.level === "level1").name) && (officeType.find(x=> x.type=== presentOffType).unitHead.includes(users.designation[value.currentOffice]))){
        alert("You are creating Top level user. Reporting officer is Not Applicable."); 

      }else{
        alert("Please check your reporting officer before final submission");
      }       
      setUsers(tempUsers);
    }
    console.log(users)
    
    const onClickFormSubmit = async (e) =>{
        e.preventDefault();
        try{     
        // Check if user has any pending join office requests 
        if (joinoffreqdata) {
          // Check for pending requests for the same office
          const pendingRequestsSameOffice = Object.values(joinoffreqdata).filter(request => 
            request.email === Auth.email && 
            request.currentOffice === value.currentOffice &&
            request.status === "joinnewoff_requested"
          );
          
          if (pendingRequestsSameOffice.length > 0) {
            alert(`You already have a pending join office request for ${value.currentOffice}. Please wait for approval or contact your reporting officer.`);
            return;
          }

          // Check for any other pending requests
          const allPendingRequests = Object.values(joinoffreqdata).filter(request => 
            request.email === Auth.email && 
            request.status === "joinnewoff_requested"
          );
          
          if (allPendingRequests.length > 0) {
            const pendingOffices = allPendingRequests.map(req => req.currentOffice).join(", ");
            if (!window.confirm(`You have pending join office requests for: ${pendingOffices}. Are you sure you want to submit another request for ${value.currentOffice}?`)) {
              return;
            }
          }
        }

        const body ={...users, "status":"joinnewoff_requested"}
        //Check if the present office type includes the present designation for unit head. 
        if(officeType.find(x=> x.type=== presentOffType).unitHead.includes(users.designation[value.currentOffice])){
          if(offices?.find(x => x.name ===  value.currentOffice)?.unitHead?.length){
            alert("Unit Head already posted");
            return
          }
          const res = await addJoinOffReq(body);
        }else {
          const res = await addJoinOffReq(body);
        }
        alert(`You have successfully generated office joining request.  Email:${users.email}, Office:${value.currentOffice}, Designation:${users.designation[value.currentOffice]} Your Office will be assigned after approval from reporting officer.`)
        
        let tempUser = structuredClone(initialUserState);
        let tempValue = structuredClone(initialValueState);
        tempValue.level0 = offices[0].name;
        tempValue.currentOffice = Object.values(offices).find( x => x.level === "level1").name
        setUsers(tempUser);
        setValue(tempValue);
        setSubdispl('none')
        setPresentOffType(Object.values(offices).find( x => x.level === "level1")?.type)
        } catch(err){
            if (!err?.response) {
                setErrMsg('No Server Response');
            } else if (err.response?.status === 409) {
                setErrMsg('Username Taken');
            } else {
                setErrMsg('Registration Failed')
            }
            // errRef.current.focus();
        }
    }

    const onClickBackArrow = (e)=>{
      let tempToggle = structuredClone(compToggle);
          tempToggle.home = true;
          tempToggle.joinOff = false;
          setCompToggle(tempToggle);
    }

  
console.log(value)
console.log(renderFields)

useEffect(() => {
  if (!officedata || !userData) return;

  const finalOfficeData = Object.values(officedata);

  // Normalize levels (convert to lowercase) and sort by level number
  finalOfficeData.sort((a, b) => {
    const numA = parseInt(a.level.replace(/level/i, ""), 10); // Case-insensitive match
    const numB = parseInt(b.level.replace(/level/i, ""), 10);
    return numA - numB;
  });

  setOffices(finalOfficeData);

  if (!value?.currentOffice?.length) {
    console.log("Entered first render");

    // Collect unique first entries for each level
    let renderArray = [];
    let seenLevels = new Set();

    for (let office of finalOfficeData) {
      const normalizedLevel = office.level.toLowerCase(); // Normalize casing

      if (!seenLevels.has(normalizedLevel)) {
        renderArray.push(office);
        seenLevels.add(normalizedLevel);
      }
    }

    setRenderFields(renderArray);

    // Find the top-level office (level1)
    const level1Office = renderArray.find(x => x.level.toLowerCase() === "level1") || {};

    let tempUser = {
      ...users,
      office: userData[Auth.id]?.office,
      currentOffice: level1Office.name || "",
      email: Auth.email,
      roles: userData[Auth.id]?.roles,
      numSuffix: userData[Auth.id]?.numSuffix
    };

    setPresentOffType(level1Office.type || "");

    let tempVal = {
      ...value,
      level0: level1Office.name || "",
      currentOffice: level1Office.name || ""
    };

    setValue(tempVal);
    setUsers(tempUser);
    setCurrentUser(userData[Auth.id]);
  }
}, [officedata, userData]);

const getOfficeLabel = (index) => {
  const filteredTypes = offices
    ?.filter((i) => i.superioroffice === value[`level${index - 1}`])
    .map(a => a.type) || [];

  const uniqueTypes = [...new Set(filteredTypes)]; // Remove duplicates

  if (uniqueTypes.length === 0) return "Not Available"; // Handle empty case

  return uniqueTypes.length === 1 
    ? uniqueTypes[0] 
    : uniqueTypes.join('/');
};

useEffect(()=>{
  if(officetype){
      setOfficeType(Object.values(officetype))
  }
},[officetype])


useEffect(()=>{
  if(designationsuffix){
      setDesigSuffix(Object.values(designationsuffix))
  }
},[designationsuffix])

useEffect(()=>{
  if(designation){
      setDesig(Object.values(designation))
  }
},[designation])
  
return (
  <>
    <BackArrowContainer onClick={onClickBackArrow}><ArrowLeftIcon /><span >Back to Change Office Req Page</span></BackArrowContainer>

    <MainHeading>
      <HeadingField>
        Join New Office
      </HeadingField>
    </MainHeading>
    

    <form onSubmit={(e)=>onClickFormSubmit(e)}>
        
    <AddUserFormContainer>
      <LabelInputWrapper>
        <TextField
          id="outlined-basic"
          size='small'
          ref={userRef}
          name='email'
          label="Email"
          value={Auth.email}
          variant="outlined"
          InputProps={{
            readOnly: true,
          }}
          // sx={{width:"100%"}}
        />      
      </LabelInputWrapper>

      <LabelInputWrapper>
          <TextField
            id="outlined-basic"
            size='small'
            ref={userRef}
            name='email'
            label="Present Main Office"
            value={Object.values(userdata)?.find(x => x.email === Auth.email)?.office.mainCharge.length? Object.values(userdata)?.find(x => x.email === Auth.email)?.office.mainCharge:"Vacant" }
            variant="outlined"
            InputProps={{
              readOnly: true,
            }}
            // sx={{width:"100%"}}
          />      
      </LabelInputWrapper>

      <LabelInputWrapper>
          <TextField
            id="outlined-basic"
            size='small'
            ref={userRef}
            name='email'
            label="Present Additional Charge Offices"
            value={Object.values(userdata)?.find(x => x.email === Auth.email)?.office.additionalCharge.length? Object.values(userdata)?.find(x => x.email === Auth.email)?.office.additionalCharge.join(", "):"No Additional Charge"}
            variant="outlined"
            InputProps={{
              readOnly: true,
            }}
            sx={{width:"150%"}}  
        />      
      </LabelInputWrapper>
    </AddUserFormContainer>          
            
    <AddUser>
      <SubHeadingField>
        Select Office, Designation etc to generate joining request.
      </SubHeadingField>         
    </AddUser>
        
    <AddUserFormContainer>
      {Array(
      Object.keys(value)
          .filter((key) => key.startsWith("level") && value[key] !== "")
          .length + 1
      )
      .fill(null)
      .map((_, index) => (
        <LabelInputWrapper1 key={index} disp={displ.level1}>
          <Autocomplete
            disablePortal
            id={`combo-box-level${index}`}
            size="small"
            value={value[`level${index}`] || null}
            onChange={(event, newValue) => onChangeuserform(event, newValue, `level${index}`)}
            options={offices
                .filter((item) => item.superioroffice === value[`level${index - 1}`])
                .map((item) => item.name)}
            sx={{ width: "50%" }}
            renderInput={(params) => <TextField {...params} label={getOfficeLabel(index)} />}
            isOptionEqualToValue={(option, value) => option === value}
            getOptionLabel={(option) => option || ""}
          />
        </LabelInputWrapper1>
      ))}

      <LabelInputWrapper1>
          <Autocomplete
            disablePortal
            id="combo-box-demo"
            size='small'
            value={users?.designation?.[value.currentOffice] || null}
            onChange={(event, newValue) => onChangeuserform(event, newValue, "designation")}
            options={desig?.map((item)=>item.name) || []}
            sx={{ width: "50%" }}
            renderInput={(params) => <TextField {...params} label={"Enter Designation"} />}
            isOptionEqualToValue={(option, value) => option === value}
            getOptionLabel={(option) => option || ""}
          /> 
    </LabelInputWrapper1>

    <LabelInputWrapper1>
          <Autocomplete
            disablePortal
            id="combo-box-demo"
            size='small'
            value={users?.designationSuffix?.[value.currentOffice] || null}
            onChange={(event, newValue) => onChangeuserform(event, newValue, "designationSuffix")}
            options={desigSuffix?.map((item)=>item.name) || []}
            sx={{ width: "50%" }}
            renderInput={(params) => <TextField {...params} label={"Enter Designation Suffix"} />}
            isOptionEqualToValue={(option, value) => option === value}
            getOptionLabel={(option) => option || ""}
          /> 
    </LabelInputWrapper1>
  </AddUserFormContainer> 

  <AddUserFormContainer>
    <LabelInputWrapper1 >
      <Autocomplete
          disablePortal
          id="combo-box-demo"
          size='small'
          value={value.charge || null}
          onChange={(event, newValue) => onChangeuserform(event, newValue, "charge")}
          options={["Main","Additional"]}
          sx={{ width: "20%" }}
          renderInput={(params) => <TextField {...params} label={"Office Charge"} />}
          isOptionEqualToValue={(option, value) => option === value}
          getOptionLabel={(option) => option || ""}
        />
      </LabelInputWrapper1>
  </AddUserFormContainer>       
        <SubmitButton type="button" disabled={!users?.designation ? true: false} onClick={(e)=>onClickConfirm(e)}>Confirm</SubmitButton>
        <div style={{display:subdispl}}>
        <SubHeadingField>
            Reporting Officer:
          </SubHeadingField>
          <TextField
            id="outlined-basic"
            size='small'
            name='reportingofficer'
            type='text'
            value = {reportingOfficer === "Not Applicable"? reportingOfficer:`${userData[reportingOfficer]?.name?.firstName} ${userData[reportingOfficer]?.name?.middleName} ${userData[reportingOfficer]?.name?.lastName} (${userData[reportingOfficer]?.designation[userData[reportingOfficer]?.office?.mainCharge]})`}
            variant="outlined"
            sx={{backgroundColor:"lightblue", width:"25%"}}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <AccountCircle />
                </InputAdornment>
              ),
            }}
            readOnly
            />
          </div>
        {/* <div style={{display:subdispl}}>
                <Label>Reporting Officer</Label>
                <input
                type="text"
                required="required"
                // The name of Reporting officer should come from users data base dynamically.
                value={reportingOfficer === "Not Applicable"? reportingOfficer:`${userData[reportingOfficer]?.name?.firstName} ${userData[reportingOfficer]?.name?.middleName} ${userData[reportingOfficer]?.name?.lastName}`} 
                name="reportingofficer"
                readOnly
                ></input>
        </div>               */}
        <SubmitButton type="submit"  style={{display:subdispl}}>Submit</SubmitButton>
        </form>
      
        </>
      )
}
export default JoinOfficeReq;

